<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Add New Custom Topic</h4>
    <button mat-button [mat-dialog-close]="" (click)="close()" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content [formGroup]="form" class="dialog-content">
    <mat-form-field class="full-width">
      <mat-label>Topic</mat-label>
      <input
        matInput
        id="topicInput"
        maxlength="50"
        formControlName="topic"
        required="true"
      /><!-- Title / Acronym-->
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>First Sub-Topic</mat-label>
      <input
        matInput
        maxlength="255"
        formControlName="subtopic"
        required="true"
      />
      <!-- Topic -->
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="right-end">
    <button
      mat-button
      (click)="onNewCustomTopic()"
      class="button-close"
      cdkFocusInitial
    >
      Save
    </button>
    <button mat-button (click)="close()" mat-dialog-close class="button-close">
      Cancel
    </button>
  </div>
</div>
